import { render, staticRenderFns } from "./ViewOrg.vue?vue&type=template&id=5a16229a&scoped=true&"
import script from "./ViewOrg.vue?vue&type=script&lang=js&"
export * from "./ViewOrg.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrg.vue?vue&type=style&index=0&id=5a16229a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16229a",
  null
  
)

export default component.exports